
import React, {  Fragment, useEffect, useState } from "react";
import Load from "./load";
import LazySection from "../components/about/LazySection";
import { useContactData } from "../hooks/useContactData";
import { CMS_API_BASE ,CUS_API_BASE,IsDevMode} from '../helper/constants';
import ReCAPTCHA from "react-google-recaptcha";
import { useLocation, useNavigate } from "react-router-dom";
import fetchAPI from "../helper/axios";
import SEO from "./seo";
import { SeoData } from "../types/seodata";
import { Helmet } from "react-helmet-async";

// Base URL for the API
const API_BASE = CMS_API_BASE;
const CustAPI_BASE = CUS_API_BASE;
interface Contoffice {
  field_contact_office_one: string;
  field_contact_office_one_descrip: string;
  field_contact_office_second: string;
  field_contact_office_second_desc: string;
  field_contact_telephone: string;
  field_email: string;
}
const ContactUsNew: React.FC = () => {
   const [verified, setVerified] = useState(false);
    const [reverified, setreVerified] = useState(false);
      const { pathname } = useLocation();
   
      const pageSEO = SeoData.find((page) => page.url === pathname);
      //const pageSEO = SeoData?.[0];
         //console.log(pageSEO);
  const { pageData: conatctData, heroImg: contactDataImg,mobheroImg: mobcontactDataImg, offices: Contantoffice, loading, error } = useContactData();
       // Form state
       const [formData, setFormData] = React.useState({
          name: '',
          email: '',
          mobile: '',
          message: ''
       });
       const [submitMessage, setSubmitMessage] = React.useState('');
       const [submitting, setSubmitting] = React.useState(false);
       const navigate = useNavigate();
        
      
const [googleData, setGoogleData] = useState<any>(null);
const [loadingGoogle, setLoadingGoogle] = useState(true);
const [googleError, setGoogleError] = useState<string | null>(null);
const [mobileError, setMobileError] = useState("");
useEffect(() => {
  let isMounted = true; // prevents memory leak

  const loadData = async () => {
    try {
      setLoadingGoogle(true);
      const response = await fetchAPI("node/68");

      if (isMounted) {
        setGoogleData(response);
      }
    } catch (err: any) {
      if (isMounted) {
        setGoogleError(err?.message || "Failed to load data");
      }
    } finally {
      if (isMounted) {
        setLoadingGoogle(false);
      }
    }
  };

  loadData();

  return () => {
    isMounted = false;
  };
}, []);
    
    const  SITE_KEY = googleData?.field_google_captcher_key[0].value || '';
   // console.log(SITE_KEY);
    //  const handleChange = (
    //      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    //    ) => {
    //      const { name, value } = e.target;
    //      if (name === "mobile") {
    //        if (!/^\d{0,10}$/.test(value)) return;
    //      }
   
    //      setFormData((prev) => ({ ...prev, [name]: value }));
    //    };
   
   const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "mobile" && !/^\d{0,10}$/.test(value)) return;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };
     // Handle form submission
    const handleSubmit = async (e: React.FormEvent) => {
       e.preventDefault();
          // if (!verified) {
          //   setreVerified(true);
          //  // alert("Please verify you are not a robot.");
          //   return;
          //  }
       
       setSubmitting(true);
       setSubmitMessage('');
   
      //  const payload = {
      //    webform_id: "react_contact_form",
      //    ...formData
      //  };
   
       try {
          let response: Response;
            
                response = await fetch(API_BASE +'/webform_rest/submit', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  // body: JSON.stringify(payload)
                  body: JSON.stringify({
                    webform_id: 'react_contact_form',
                    name: formData.name,
                    email: formData.email,
                    mobile: '+91' + formData.mobile,
                    message: formData.message
                  
                  }),
                });
                  
      
        if (response.ok) {
           //setSubmitMessage('✅ Message sent successfully!');
            navigate("/thank-you");
            setFormData({ name: '', email: '', mobile: '', message: '' });
          } else {
           const text = await response.text();
           setSubmitMessage(`❌ Submission failed: ${text}`);
         }
       } catch (err: any) {
         console.error(err);
         setSubmitMessage(`⚠ Something went wrong: ${err.message}`);
       } finally {
         setSubmitting(false);
       }
    };

    const isValidMobile = (mobile: string) => /^[6-9]\d{9}$/.test(mobile);
      /* ------------------ SUBMIT (FAST VERSION) ------------------ */
 const handleSubmitfast = (e: React.FormEvent) => {
  e.preventDefault();
  if (submitting) return;
    if (!verified) {
            setreVerified(true);
            return;
    }
    if (!isValidMobile(formData.mobile)) {
      setMobileError("Enter valid 10-digit mobile number");
      return;
    }
  setSubmitting(true);

  // Instant UX
  navigate("/thank-you");

  const controller = new AbortController();
  setTimeout(() => controller.abort(), 10000);

  fetch(API_BASE + "/webform_rest/submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    signal: controller.signal,
    body: JSON.stringify({
      webform_id: "react_contact_form",
      name: formData.name,
      email: formData.email,
      mobile: "+91" + formData.mobile,
      message: formData.message,
      // optional: captcha token here
    }),
  })
    .then((res) => {
      if (!res.ok) {
        console.error("Webform submit failed:", res.status);
      }
    })
    .catch((err) => {
      console.error("Webform submit error:", err);
    })
    .finally(() => {
      setSubmitting(false);
    });

  setFormData({ name: "", email: "", mobile: "", message: "" });
};
  return (
    <>
    {!loading && pageSEO && (
        <>
            <Fragment>
              <head>
            {/* ✅ Primary Title */}
              {pageSEO?.recommended_title && <title>{pageSEO?.recommended_title}</title>}
              {/* ✅ Meta Description */}
              {pageSEO?.recommended_title && <meta name="title" content={pageSEO?.recommended_title} />}

              {/* ✅ Meta Description */}
              {pageSEO?.meta_description && <meta name="description" content={pageSEO?.meta_description} />}

              {/* ✅ Secondary Meta (Suggested Description) */}
              {pageSEO?.suggested_desc && <meta name="summary-description" content={pageSEO?.suggested_desc} />}
              
                {/* ✅ Secondary Meta (Suggested h1) */}
              {pageSEO?.suggested_h1 && <meta name="summary-h1" content={pageSEO?.suggested_h1} />}
            
              {/* ✅ Canonical URL */}
              {pageSEO?.canonical && <link rel="canonical" href={`${pageSEO?.canonical}`} />}

              {/* ✅ Open Graph */}
              {pageSEO?.recommended_title && <meta property="og:title" content={pageSEO?.recommended_title} />}
              {pageSEO?.meta_description && (
                <meta property="og:description" content={pageSEO?.meta_description} />
              )}
              {pageSEO?.canonical && <meta property="og:url" content={`${pageSEO?.canonical}`} />}
              <meta property="og:type" content="website" />

              {/* ✅ Twitter Meta */}
              <meta name="twitter:card" content="summary_large_image" />
              {pageSEO?.recommended_title && <meta name="twitter:title" content={pageSEO?.recommended_title} />}
              {pageSEO?.meta_description && (
                <meta name="twitter:description" content={pageSEO?.meta_description} />
              )}
           </head>
          </Fragment>
        
              {pageSEO?.suggested_h1 &&<h1 style={{
                  position: "absolute",
                  width: 1,
                  height: 1,
                  overflow: "hidden",
                  clip: "rect(0 0 0 0)",
                }}>{pageSEO?.suggested_h1}</h1>}
        </>
      )}

  <main className="main">
{loading ? (
      <Load />
    ) : (
      <>
       {/* Hero Section */}
      <section id="hero" className="hero section dark-background contact contact-banner">
          <img src={contactDataImg?.thumbnail?.[0]?.url} alt="" className="hero-bg d-xl-block d-lg-block d-md-block d-sm-none w-100" loading="lazy" decoding="async" />
          <img src={mobcontactDataImg?.thumbnail?.[0]?.url} alt="" className="hero-bg d-xl-none d-lg-none d-md-none d-sm-block w-100" loading="lazy" decoding="async" />

      </section>{/* /Hero Section */}
     {/* <!-- About Section --> */}
      <section id="about" className="about section mt-3">

          <div className="container" data-aos="fade-up" data-aos-delay="100">
              <div className="row gx-2  text-start gy-md-5">

                  <div className="col-xl-6 col-lg-6 content pe-lg-5">
                      {/*<h3>About Us</h3>*/}
                      <label className="label-title mb-lg-4" >
                        {conatctData?.field_description?.[0]?.value}
                      </label>

                      <p dangerouslySetInnerHTML={{ __html:conatctData?.field_content?.[0]?.value }} />
                      
                  </div>

                  <div className="col-lg-6 pt-lg-0 pt-sm-4">
                      <form onSubmit={handleSubmitfast} className="php-email-form" data-aos="fade-up" data-aos-delay="200">
                          <div className="row gy-4">

                              <div className="col-md-12">
                                  <input type="text" name="name" className="form-control" placeholder="Name *" value={formData.name}
                                  onChange={handleChange} required />
                              </div>

                              <div className="col-md-12 ">
                                  <input type="email" className="form-control" name="email" placeholder=" Email  *"
                                  value={formData.email}
                                onChange={handleChange} required />
                              </div>

                              <div className="col-md-12 d-flex">
                                <span className="input-group-text nocode">+91</span>
                                  <input type="number" className="form-control form-control-border" name="mobile" placeholder="Mobile  *" value={formData.mobile}
                                  onChange={handleChange} required />
                              </div>
                              {mobileError && <small className="text-danger mt-0 col-sm-12">{mobileError}</small>}

                              <div className="col-md-12">
                                  <textarea className="form-control" name="message"  placeholder="Your Message here" value={formData.message}
                                onChange={handleChange} required />
                              </div>

                                <div className="col-md-12">
      <div className="form-check">
        <input 
          type="checkbox" 
          className="form-check-input" 
          id="authorizationCheckbox"
          name="authorization"
          
          onChange={handleChange}
          required
        />
        <label className="form-check-label" htmlFor="authorizationCheckbox">
          I hereby authorize to send notifications on SMS / Messages / Promotional / informational messages.*
        </label>
      </div>
      {/* {authorizationError && <small className="text-danger d-block mt-1">{authorizationError}</small>} */}
    </div>

                              <div className='col-md-12'>
                                {!loadingGoogle && SITE_KEY && (
                                  <ReCAPTCHA
                                        sitekey={SITE_KEY}
                                        onChange={() => setVerified(true)} // called when checked
                                        onExpired={() => setVerified(false)} // auto unverify on expiry
                                      />
                                )}
                                </div>
                                <div className="col-md-12 mt-0">
                                    {reverified && (
                                      <p className="text-red-500 text-sm text-danger mb-0">
                                        Please complete the reCAPTCHA
                                      </p>
                                    )}
                                </div>
                              <div className="col-md-12 ">
                                 <button className="btn btn-success" type="submit" disabled={submitting}>
                                  {submitting ? "Sending..." : "Send Message"}
                                </button>

                                {submitMessage && <p className="mt-2">{submitMessage}</p>}
                              </div>

                          </div>
                      </form>
                  </div>

              </div>
          </div>

      </section>
      {/* <!-- /About Section --> */}
        <section id="" className="abtBlueprintforSuccess  section mt-0 bg-grey-gradient">
      
                {/* Section Title */}
                <div className="container " data-aos="fade-up">
                    <div className="row gx-3">
                        <div className=" col-md-12 col-sm-12 pb-5 text-center">
                            <h2> {conatctData?.field_title[0]?.value ?? ""}</h2>
                        </div>
                        <LazySection>
                          <div className="row gx-2">
                            {Contantoffice.length > 0 ? (
                              Contantoffice.map((cont, index) => (
                                <div className="col-lg-4 col-sm-12 " key={index}>
                                  <div className={`contactOffice me-md-3 ${[0, 1, 3,4].includes(index) ? "border-end" : ""}`}>
                                    <h6 className="text-black">{cont.field_contact_office_one}</h6>
                                    <p dangerouslySetInnerHTML={{ __html:cont.field_contact_office_one_descrip }} />
                                    <h6 className="text-black">{cont.field_contact_office_second}</h6>
                                    <p  dangerouslySetInnerHTML={{ __html:cont.field_contact_office_second_desc }} />
                                      {cont.field_contact_telephone && (
                                    <><h6 className="text-black">
                                        Telephone
                                      </h6>
                                       <p className="contactOfficeAdd" dangerouslySetInnerHTML={{ __html:cont.field_contact_telephone }} /> </>
                                   )}
                                    {/* <h6 className="text-black" >
                                      Telephone
                                    </h6>
                                    <p className="contactOfficeAdd" dangerouslySetInnerHTML={{ __html:cont.field_contact_telephone }} />  */}
                                    {cont.field_email && (
                                    <><h6 className="text-black">
                                        Email
                                      </h6><p>{cont.field_email}</p></>
                                   )}
                                    
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p>No data found.</p>
                            )}
                          </div>
                        </LazySection>
                       
      
                    </div>
                </div>{/* End Section Title */}
      
      
                </section>
        </>
    )}
  </main>
  </>
  )
}

export default ContactUsNew;